// frontend/src/components/ModalShell.js
import React from 'react';
import { createPortal } from 'react-dom';
import './ModalShell.css';

export default function ModalShell({ title, open, onClose, children, footer }) {
  if (!open) return null;

  return createPortal(
    <div
      className="modal-shell__overlay"
      role="dialog"
      aria-modal="true"
      aria-label={title}
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div className="modal-shell__panel">
        <div className="modal-shell__header">
          <div className="modal-shell__title">{title}</div>
          <button type="button" className="modal-shell__close" onClick={onClose} aria-label="Close modal">
            ×
          </button>
        </div>

        <div className="modal-shell__body">{children}</div>

        {footer ? <div className="modal-shell__footer">{footer}</div> : null}
      </div>
    </div>,
    document.body
  );
}